import api from "@/utils/api";
const { oauth, union, cupid, young } = api;
//根据cookie获取用户登录信息
const getUserToken = (data) => {
  return oauth.post("ajax/get_token.php", data);
};
// 应届生获取登录信息
const getYjsUsetToken = (data) => {
  return union.get("api_young_relogin.php", data);
};

// 获取求职意向列表（51job）
const get51JobIntentions = (params) => {
  return cupid.get("/open/intentions", { params });
};

// 获取求职意向列表（应届生）
const getYJSIntentions = (params) => {
  return young.get("/open/yjs/intention/get", { params });
};

// 获取当前定位默认城市
const getDefaultCity = (params) => {
  return cupid.get("/open/noauth/index/default-city", { params });
};

// 获取最优简历-51job
const getBestResume = () => {
  return cupid.get("/open/resume/best-resume");
};

// 获取微信绑定状态
const getBindStatus = () => {
  return cupid.get("/open/wechat/wx/bindStatus");
};

export default {
  getUserToken,
  getYjsUsetToken,
  get51JobIntentions,
  getDefaultCity,
  getBestResume,
  getBindStatus,
  getYJSIntentions
};
